import { SelectFieldPassengerAndLuggage } from 'components/Global';
import SelectFieldCar from 'components/Global/SelectFieldCar';
import SelectFieldDropdown from 'components/Global/SelectFieldDropdown';
import { getVehiclesByFilter } from 'features/vehicle/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const DetailSewa = ({
  selectedCar,
  setSelectedCar,
  rentalLocation,
  orderData,
  setOrderData,
  getSubserviceId,
  selectedPaymentType,
  setSelectedPaymentType,
  mappedPaymentType,
  selectedLuggage,
  selectedPassengers,
  setSelectedLuggage,
  setSelectedPassengers,
  allRentTime,
}) => {
  const dispatch = useDispatch();

  const { data: dataVehicle } = useSelector((state) => state.vehicle);

  const [allVehicle, setAllVehicle] = useState([]);
  const [vehicleInput, setVehicleInput] = useState('');

  useEffect(() => {
    if (
      !rentalLocation ||
      !orderData.order_detail.start_booking_date ||
      !orderData.order_detail.end_booking_date ||
      allRentTime?.length === 0 ||
      allRentTime[0]?.booking_start_time === ''
    )
      return;

    const payload = {
      locationRental: rentalLocation.id,
      startTrip: `${orderData.order_detail.start_booking_date} ${allRentTime[0]?.booking_start_time}`,
      endTrip: `${orderData.order_detail.end_booking_date} ${allRentTime[0]?.booking_end_time}`,
      customOrder: true,
      page: 0,
      limit: 0,
      supportCharter: true,
    };

    dispatch(getVehiclesByFilter(payload));
  }, [orderData.order_detail.start_booking_date, orderData.order_detail.end_booking_date, allRentTime, rentalLocation]);

  useEffect(() => {
    if (Object.keys(dataVehicle).length === 0) return;
    if (dataVehicle.vehicles === null) {
      setAllVehicle([]);
      return;
    }
    if (dataVehicle?.pagination.page > 1) {
      setAllVehicle((prevState) => [...prevState, ...dataVehicle.vehicles]);
    } else {
      setAllVehicle(dataVehicle.vehicles);
    }
  }, [dataVehicle]);

  const selectVehicleHandler = (vehicleId, resetVehicle) => {
    if (vehicleId === '') {
      setVehicleInput(resetVehicle);
      return;
    }
    setOrderData({ ...orderData, order_detail: { ...orderData.order_detail, vehicle_id: vehicleId } });
    setVehicleInput(resetVehicle);
  };

  const passangerAndLuggageHandler = (passengers, luggage) => {
    setSelectedPassengers(passengers);
    setSelectedLuggage(luggage);
    setOrderData({
      ...orderData,
      order_detail: {
        ...orderData.order_detail,
        adult_passenger: passengers.adults,
        child_passenger: passengers.child,
        baggage: luggage.luggage,
      },
    });
  };

  return (
    <div className="edit-car-charter__content-data__detail-sewa">
      <h2>Detail Sewa</h2>
      <div className="edit-car-charter__content-data__detail-sewa-form">
        <SelectFieldCar
          label="Pilih Mobil"
          htmlFor="pilih-mobil"
          placeholder="Cari Mobil.."
          data={allVehicle}
          selectedCar={selectedCar}
          onSelectCar={setSelectedCar}
          value={vehicleInput}
          onChange={(e) => setVehicleInput(e.target.value)}
          onClick={selectVehicleHandler}
          payloadFilter={{
            locationRental: rentalLocation?.id,
            startTrip: `${orderData.order_detail.start_booking_date} ${orderData.order_detail.start_booking_time}`,
            endTrip: `${orderData.order_detail.end_booking_date} ${orderData.order_detail.end_booking_time}`,
            supportDriver: !orderData.order_detail.without_driver,
            customOrder: true,
            page: 0,
            limit: 0,
            subServiceId: getSubserviceId(),
          }}
          disable={
            !rentalLocation ||
            orderData.order_detail.start_booking_date === '' ||
            orderData.order_detail.end_booking_date === '' ||
            allRentTime?.length === 0 ||
            allRentTime[0]?.booking_start_time === ''
          }
        />

        <SelectFieldDropdown
          label="Tipe Pembayaran"
          htmlFor="tipe-pembayaran"
          value={selectedPaymentType}
          data={mappedPaymentType}
          onChange={(e) => {
            setSelectedPaymentType(e.target.id);
            setOrderData({
              ...orderData,
              type: mappedPaymentType?.find((item) => item.id == e.target.id)?.value,
            });
          }}
          placeholder="Tipe Pembayaran"
          disable={
            orderData.order_detail.start_booking_date === '' ||
            orderData.order_detail.end_booking_date === '' ||
            allRentTime?.length === 0 ||
            allRentTime[0]?.booking_start_time === '' ||
            orderData.order_detail.vehicle_id === ''
          }
        />

        <SelectFieldPassengerAndLuggage
          label="Jumlah Penumpang"
          htmlFor="passengers-and-suitcase"
          selectedLuggage={selectedLuggage}
          selectedPassengers={selectedPassengers}
          onSelect={passangerAndLuggageHandler}
        />
      </div>
    </div>
  );
};

export default DetailSewa;
